import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  NavLink,
} from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';

import { useTranslation } from 'react-i18next';

import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';

import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// icon
import VisibilityIcon from '@material-ui/icons/Visibility';
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// component
import Login from './login';
import DataViews from './dataView/DataViews';
import LinkSite from './LinkSite';
import User from './user/User';

// style
import { styles } from './styleMap';
// import { globalStyle } from '../../global/style';
import './style.scss';
import '../../global/styles.scss';
import './styles.css';

// images
import Th from '../../assets/fag/th.png';
import En from '../../assets/fag/en.png';

// context
import ModeContext from '../../context/ModeContext';
import UserContext from '../../context/UserContext';

// GoogleAnalytics
import GA from '../../utils/tracking/GoogleAnalytics';

const initPath = `/${process.env.REACT_APP_PATH}`;

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={2} m={1}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

// const MenuItem = withStyles((theme) => ({
//   root: {
//     '&:focus': {
//       backgroundColor: theme.palette.primary.main,
//       '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
//         color: theme.palette.common.white,
//       },
//     },
//   },
// }))(MenuItem);

export default function Header() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  // const theme = useTheme();
  // const [age, setProvince] = React.useState('10');
  const currentDate = i18n.language === 'th' ? moment().add(543, 'year').format('DD MMMM YYYY') : moment().lang('en').format('DD MMMM YYYY');

  const [value, setValue] = React.useState(0);
  const [open] = React.useState(false);
  const [state, setState] = React.useState({
    province: '10',
    right: false,
  });

  const {
    selectList, currentSelectList, currentTextSelectList, handleSelectListChange,
  } = useContext(ModeContext);
  const { userProfile, userIsLogin } = useContext(UserContext);

  const handleChange = (event, newValue) => {
    // setProvince(event.target.value);
    setValue(newValue);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
    >
      <AppBar position="static" color="inherit" style={{ background: 'transparent', boxShadow: 'none' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-labelledby="simple tabs example"
          textColor="primary"
          indicatorColor="primary"
          variant="fullWidth"
        >
          <Tab icon={<VisibilityIcon />} label={t('ดูข้อมูล')} {...a11yProps(0)} textColor="colorPrimary" />
          <Tab icon={<PeopleIcon />} label={t('สำหรับเจ้าหน้าที่')} {...a11yProps(1)} style={{ whiteSpace: 'noWrap' }} />
        </Tabs>
        <Divider />
      </AppBar>
      <TabPanel value={value} index={0}>
        <DataViews />
        <Box mt={6}>
          <Grid item xs="auto" md="auto">
            <LinkSite />
          </Grid>
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Login />
        <User />
      </TabPanel>
    </div>
  );

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentTH = i18n.language === 'th';
  const currentEN = i18n.language === 'en';

  const currentLang = currentTH ? {
    label: 'th', src: Th, Text: 'ไทย', alt: 'ภาษาไทย',
  } : {
    label: 'en', src: En, Text: 'En', alt: 'English',
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      {GA.init('waterinfo') && <GA.RouteTracker />}
      <Box m={2} mb={6} display="flex">
        <Box>
          <Box>
            <Hidden smDown>
              <Box height={30} display="flex" alignItems="center" flexDirection="row" justifyContent="flex-end">
                {userIsLogin && (
                  <Box mr={7} display="flex" alignItems="center">
                    <Box><PersonIcon /></Box>
                    <Box>
                      {userProfile.firstname}
                      {' '}
                      {userProfile.lastname}
                    </Box>
                  </Box>
                )}
                <Box>
                  <IconButton
                    aria-label={currentLang.label}
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    variant="contained"
                    color="primary"
                    onClick={handleClick}
                    data-cy="display-lang"
                  >
                    <img src={currentLang.src} alt={currentLang.alt} />
                    <Box pl={1}>
                      <Typography variant="h6" style={{ fontSize: '1rem' }} noWrap>
                        {currentLang.Text}
                      </Typography>
                    </Box>
                    <ExpandMoreIcon />
                  </IconButton>

                  <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <Box px={1}>
                      <Typography noWrap variant="caption">
                        {t('เปลี่ยนภาษา')}
                      </Typography>
                    </Box>
                    <Divider />

                    {currentTH && (
                      <MenuItem onClick={() => changeLanguage('en')} data-cy="change-language-map">
                        <ListItemIcon>
                          <img src={En} alt="En" />
                        </ListItemIcon>
                        <Typography className={classes.lang} noWrap>
                          En
                        </Typography>
                      </MenuItem>
                    )}

                    {currentEN && (
                      <MenuItem onClick={() => changeLanguage('th')} data-cy="change-language-map">
                        <ListItemIcon>
                          <img src={Th} alt="ภาษาไทย" />
                        </ListItemIcon>
                        <Typography className={classes.lang} noWrap>
                          ไทย
                        </Typography>
                      </MenuItem>
                    )}

                  </StyledMenu>
                </Box>
              </Box>
            </Hidden>
            <Box>
              <NavLink to={initPath}>
                <Typography noWrap className={classes.titleTH}>
                  {t('สถานการณ์น้ำประเทศไทย')}
                </Typography>
              </NavLink>
            </Box>
          </Box>
          <Box display="flex" justifyContent="center" alignItems="center" className={classes.selectBox}>
            <Hidden smDown>
              <Box width="50%">
                <FormControl className={`${classes.formControl} ${classes.selectProvinces}`}>
                  <Select
                    labelId="main-map-select"
                    id="main-map-select"
                    // onClose={handleClose}
                    // onOpen={handleOpen}
                    value={currentSelectList}
                    onChange={handleSelectListChange}
                    inputProps={{
                      classes: {
                        icon: classes.icon,
                      },
                    }}
                    disableUnderline
                    className={classes.buttonSelectProvinces}
                  >
                    <MenuItem value="0">
                      {t(currentTextSelectList)}
                    </MenuItem>
                    {selectList !== null && selectList.map((row) => (
                      <MenuItem
                        key={_.uniqueId()}
                        value={row.code}
                        className={classes.listSelectProvinces}
                      >
                        {t(row.name)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Hidden>
            <Box width={{ xs: '100%', sm: '50%', md: '50%' }} className={classes.dateTime}>
              {currentDate}
            </Box>
          </Box>
        </Box>
        <Box m={{ xs: 0, sm: 3, md: 7 }} className={classes.buttonMenuMoblie}>
          {['right'].map((anchor) => (
            <IconButton
              key="key"
              color="inherit"
              aria-label="open drawer"
              id="main-open-drawer"
              // edge="end"
              onClick={toggleDrawer(anchor, true)}
              className={`${clsx(open && classes.hide)}`}
            >
              <MenuIcon fontSize="large" />
            </IconButton>
          ))}
        </Box>
      </Box>

      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <div className={classes.drawerHeader}>
              <IconButton id="main-drawer-close-button" onClick={toggleDrawer(anchor, false)}>
                <CloseIcon />
              </IconButton>
            </div>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}

    </>
  );
}
